export default __webpack_public_path__ + "static/media/portfolio-hover-194.32e52d68.jpg";